<template>
  <v-stepper v-model="currentStep" show-actions class="elevation-0">
    <v-stepper-header class="elevation-0">
      <v-stepper-item
        :value="1"
        :color="!!newItem.type ? 'success' : 'primary'"
        :complete="!!newItem.type"
      >
        <span v-if="newItem.type">
          Inventory Type: {{ newItem.type.name }}
        </span>
        <span v-else> Inventory Type </span>
      </v-stepper-item>

      <v-divider />
      <v-stepper-item
        :value="2"
        :editable="!!newItem.type"
        :complete="(!!newItem.pSpot || !!newItem.website) && currentStep > 2"
        :color="!!newItem.pSpot || !!newItem.website ? 'success' : 'primary'"
        :rules="
          currentStep < 2
            ? undefined
            : [() => !!specsForm || 'Please select a fill in Specs']
        "
      >
        Specifications
      </v-stepper-item>
      <v-divider />
      <v-stepper-item
        :editable="!!newItem.type"
        :value="3"
        :complete="!!newItem.audience && currentStep > 3"
        :color="!!newItem.audience ? 'success' : 'primary'"
        :rules="
          currentStep < 3
            ? undefined
            : [() => !!audienceForm || 'Please select an audience']
        "
      >
        Audience & Target
      </v-stepper-item>
      <v-divider />
      <v-stepper-item :value="4" :editable="!!newItem.type">
        Stats Preview
      </v-stepper-item>
    </v-stepper-header>

    <v-stepper-window>
      <v-stepper-window-item :value="1">
        <InventoryItemTypeSelector
          ref="typeSelector"
          v-model="newItem.type"
          @next="next"
        />
      </v-stepper-window-item>

      <v-stepper-window-item :value="2">
        <v-form
          v-model="specsForm"
          validate-on="input"
          fast-fail
          @update:model-value="
            (v) => (v === null ? (specsForm = true) : (specsForm = v))
          "
        >
          <!-- this is a fast-hack to make it real, from some reason form returns null during initialization...  -->
          <InventoryItemDeviceSpecs
            v-if="newItem.type && newItem.type.code === 'P_SPOT'"
            v-model="newItem.pSpot"
            @next="next"
          />
          <InventoryItemWebsiteSpecs
            v-else-if="newItem.type && newItem.type.code === 'WEBSITE'"
            v-model="newItem.website"
            @next="next"
          />
        </v-form>
      </v-stepper-window-item>

      <v-stepper-window-item :value="3">
        <v-form
          v-model="audienceForm"
          fast-fail
          @submit.prevent
          @update:model-value="
            (v) => (v === null ? (audienceForm = true) : (audienceForm = v))
          "
        >
          <InventoryItemAudienceSelector
            v-model="newItem.audience"
            @next="next"
            @prev="prev"
          />
        </v-form>
      </v-stepper-window-item>
      <v-stepper-window-item :value="4">
        <v-form
          v-model="statsForm"
          fast-fail
          @submit.prevent
          @update:model-value="
            (v) => (v === null ? (statsForm = true) : (statsForm = v))
          "
        >
          <InventoryItemStats v-model="newItem.stats" />
        </v-form>
      </v-stepper-window-item>
    </v-stepper-window>
    <v-stepper-actions
      :disabled="disabled"
      @click:next="next"
      @click:prev="prev"
    >
      <template #next>
        <v-btn
          :disabled="!isStepValid(currentStep)"
          @click.prevent.stop="next"
          color="primary"
        >
          <span
            v-if="currentStep === 4"
            class="d-flex align-center justify-center"
          >
            Submit
          </span>
          <span v-else> Next </span>
        </v-btn>
      </template>
    </v-stepper-actions>
  </v-stepper>
</template>


<script>
import InventoryItemAudienceSelector from "../../molecules/inventoryItem/InventoryItemAudienceSelector.vue";
import InventoryItemDeviceSpecs from "../../molecules/inventoryItem/InventoryItemDeviceSpecs.vue";
import InventoryItemStats from "../../molecules/inventoryItem/InventoryItemStats.vue";
import InventoryItemTypeSelector from "../../molecules/inventoryItem/InventoryItemTypeSelector.vue";
import InventoryItemWebsiteSpecs from "../../molecules/inventoryItem/InventoryItemWebsiteSpecs.vue";

export default {
  components: {
    InventoryItemTypeSelector,
    InventoryItemAudienceSelector,
    InventoryItemDeviceSpecs,
    InventoryItemWebsiteSpecs,
    InventoryItemStats,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["submit"],
  data() {
    return {
      currentStep: 1,

      audienceForm: true,
      specsForm: true,
      statsForm: true,

      newItem: {
        name: null,

        pSpot: null,
        website: null,
        stats: null,
        type: null,
        audience: null,
      },
    };
  },

  computed: {
    disabled() {
      return this.currentStep === 1
        ? "prev"
        : this.currentStep === 3
        ? "next"
        : undefined;
    },
  },
  methods: {
    isStepValid(step) {
      console.log("isStepValid", this.newItem);

      switch (step) {
        case 1:
          return !!this.newItem.type;

        case 2:
          return (
            (!!this.newItem.website || !!this.newItem.pSpot) && this.specsForm
          );

        case 3:
          return !!this.newItem.audience && this.audienceForm;

        case 4:
          return (
            !!this.newItem.audience &&
            !!this.newItem.type &&
            (!!this.newItem.pSpot || !!this.newItem.website) &&
            !!this.newItem.stats &&
            this.statsForm &&
            !!this.newItem.audience.countries.length
          );
        default:
          return true;
      }
    },
    prev() {
      this.currentStep--;
    },
    next() {
      if (this.isStepValid(this.currentStep) && this.currentStep < 4)
        this.currentStep++;
      else if (this.currentStep === 4) {
        console.log("Submit", this.newItem);

        this.$emit("submit", this.newItem);
      }
    },
    reset() {
      this.currentStep = 1;
      this.newItem = {
        type: null,
        audience: {},
        name: null,
        description: null,
      };
    },
  },
};
</script>